import styled from 'styled-components';

export const Stats = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.5rem;
  margin-top: 1rem;
`;

export const Stat = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  strong {
    font-size: 2rem;
    line-height: 1.1;
    color: ${({ theme }) => theme.purple};
  }

  span {
    font-size: 0.85rem;
    text-transform: uppercase;
    color: ${({ theme }) => theme.black};
    opacity: 0.7;
  }
`;

export const Actions = styled.div`
  display: flex;
  width: 100%;
`;

export const ActionButton = styled.button<{ variant: 'primary' | 'secondary' }>`
  flex: 1;
  border: 0;
  padding: 0.9rem 0.5rem;
  font-size: 1.1rem;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;
  background-color: ${({ variant, theme }) => (variant === 'primary' ? theme.purple : '#999')};

  &:hover {
    filter: brightness(1.1);
  }

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;
